//---------------------
// save current counts
//---------------------
export default function saveCurrentCounts(counts) {
  // ----------------------
  // check got counts array
  // ----------------------
  if (!Array.isArray(counts)) return null
  //--------------------------------------------------------------------
  // create array with specified props (editable or keys) for each count
  //--------------------------------------------------------------------
  const original_counts = counts.map((count) => ({
    name: count.name,
    id: count?.id ?? null, // character count id if existing (should be there)
    value: count.value,
  }))
  return original_counts
}